<template>
  <div class="information meaasgeBox">
    <!-- 头部 -->
    <div class="information-haeder-box">
      <div class="information-haeder">
        <div>
          <div class="quan" @click="goback">
            <img src="../assets/img/views/jiantou.png" alt />
          </div>
          <span class="xiangq">{{ $route.meta.title }}</span>
        </div>

        <div v-if="types != '首页监测'">
          <el-button
            type="primary"
            class="haeder-fuzhi"
            size="small"
            @click="copy(textData)"
            >一键复制</el-button
          >
          <el-button
            v-if="$store.state.user.isreport"
            type="primary"
            plain
            size="small"
            style="margin-left: 10px"
            @click="dataReport(textData)"
          >
            {{ textData.isReport == 1 ? "已上报" : "数据上报" }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 面包屑 -->
    <el-breadcrumb separator-class="  " class="breadcrumb">
      <el-breadcrumb-item v-if="types == '首页监测'" :to="{ path: '/index' }"
        >预警信息</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else :to="{ path: '/message/index' }"
        >实时信息</el-breadcrumb-item
      >

      <el-breadcrumb-item>
        <span class="breadcrumb-meaasge">/</span>
        信息详情
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 外面的大盒子 -->
    <div v-loading="loading" class="information-box">
      <div class="informaton-main">
        <div class="main-top">
          <div class="main-top-left"></div>
          <!-- 中间部分 -->
          <div class="main-top-center">
            <div class="comment-box-yujing-box">
              <div
                v-if="textData.isEarlyWarn == 1 || textData.warningFlag == 1"
                class="comment-box-yujing"
                style="
                  height: 20px;
                  margin-left: 0;
                  margin-right: 16px;
                  flex-shrink: 0;
                "
              >
                已预警
              </div>
              <p
                v-html="textData.title ? textData.title : '无'"
                class="center-title"
              ></p>
              <img
                class="zb_sentiment_copy"
                style="width: 24px; height: 24px"
                src="../assets/img/views/copy_b.png"
                @click="myCopy(item, 7)"
                alt
              />
            </div>
            <div class="caozuo-center">
              <div
                :class="[
                  'type',
                  textData.tonalState == 2
                    ? 'red'
                    : textData.tonalState == 1
                    ? 'neutral'
                    : 'obverse',
                ]"
              >
                {{
                  textData.tonalState == 2
                    ? "负面"
                    : textData.tonalState == 0
                    ? "正面"
                    : "中性"
                }}
              </div>
              <div v-if="textData.mediaLink != null" class="type website">
                {{ textData.mediaLink }}
              </div>
              <span class="original" @click="lookOriginal(textData.website)"
                >原文链接</span
              >
              <img
                class="zb_sentiment_copy"
                src="../assets/img/views/copy_b.png"
                @click="myCopy(item, 8)"
                alt
              />
              <div @click="quickCopy(textData)" class="quick_copy">
                <span
                  style="margin: 0; color: #2e59ec; font-size: 16px"
                  class="el-icon-link"
                ></span>
                复制链接和标题
              </div>
              <div class="center-timer">
                发布时间:
                <span>
                  {{ textData.releaseTime ? textData.releaseTime : "无" }}
                </span>
              </div>
            </div>
            <div class="center-bottom">
              <span class="center-meiti">
                作者ID：
                <span>
                  {{ textData.authorId ? textData.authorId : "无" }}
                </span>
                <img
                  class="zb_sentiment_copy"
                  src="../assets/img/views/copy_b.png"
                  @click="myCopy([textData.authorId], 9)"
                  alt
                />
              </span>
              <span class="center-source">
                媒体性质:
                <span>
                  {{
                    textData.mediaLink +
                    (textData.mediaAttribute
                      ? "/" + textData.mediaAttribute
                      : "") +
                    (textData.mediaLevel ? "/" + textData.mediaLevel : "")
                  }}
                </span>
                <img
                  class="zb_sentiment_copy"
                  src="../assets/img/views/copy_b.png"
                  @click="
                    myCopy(
                      [
                        textData.mediaLink,
                        textData.mediaAttribute,
                        textData.mediaLevel,
                      ],
                      1
                    )
                  "
                  alt
                />
              </span>
              <span class="center-source">
                来源/作者:
                <span>
                  {{
                    (textData.source ? textData.source : "无") +
                    "/" +
                    (textData.author ? textData.author : "无")
                  }}
                </span>
                <img
                  class="zb_sentiment_copy"
                  src="../assets/img/views/copy_b.png"
                  @click="myCopy([textData.source, textData.author], 2)"
                  alt
                />
              </span>
              <span v-if="textData.eventClass" class="center-fenlei">
                事件分类:
                <span>{{ textData.eventList[0] }}</span>
                <el-tooltip
                  v-if="textData.eventClass && textData.eventList.length >= 2"
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content" v-html="textData.eventClass"></div>
                  <span class="gengduo">(更多)</span>
                </el-tooltip>
                <img
                  class="zb_sentiment_copy"
                  src="../assets/img/views/copy_b.png"
                  @click="myCopy(textData.eventClass, 3)"
                  alt
                />
              </span>
              <span class="center-fenlei" v-else>
                事件分类: 无
                <img
                  class="zb_sentiment_copy"
                  src="../assets/img/views/copy_b.png"
                  @click="myCopy(textData.eventClass, 3)"
                  alt
                />
              </span>
            </div>
            <div class="center-key-box">
              <div class="center-key">
                关键字:
                <div v-if="textData.keywordList">
                  <span
                    v-for="(ite, indx) in textData.keywordList"
                    :class="[
                      ite !=
                      textData.keywordList[textData.keywordList.length - 1]
                        ? 'styleMargin'
                        : '',
                    ]"
                    :key="indx"
                  >
                    {{ ite }}
                  </span>
                </div>
                <span v-else>无</span>
              </div>
              <div
                v-if="
                  textData.keyword &&
                  textData.keywordArry &&
                  textData.keywordArry.length > 10
                "
                class="gengduo-link-box"
              >
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content" v-html="textData.keyword"></div>
                  <span class="gengduo-link">(更多)</span>
                </el-tooltip>
              </div>
              <img
                class="zb_sentiment_copy"
                src="../assets/img/views/copy_b.png"
                @click="myCopy(textData.keyword, 4)"
                alt
              />
            </div>
          </div>
          <div class="main-top-right"></div>
        </div>
        <div style="padding: 32px 210px 0 210px; min-height: 430px">
          <p
            v-html="item ? item : ''"
            class="main-text"
            v-for="(item, index) in textData.contentList"
            :key="index"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMsginfo, dataReport } from "../api/message/list";
import { monitorIndex } from "../api/index/index";
export default {
  data() {
    return {
      loading: true,
      dataId: "",
      textData: {},
      keyList: [],
      organId: "",
    };
  },
  props: {
    types: {
      type: String,
    },
    dataIds: {
      type: String,
    },
    montype: {
      type: Number,
    },
    cityId: {
      type: Number,
    },
  },
  methods: {
    goback() {
      if (this.types == "首页监测") {
        this.$router.push({
          path: "/index",
        });
        return;
      }
      this.$router.push("/message/index");
    },
    // 一键复制
    copy(item) {
      this.$publicFun.customCopy2(item);
    },
    //复制链接与标题
    quickCopy(msg) {
      let str = "";
      str = "标题：" + msg.title + "\n" + "链接：" + msg.website;
      this.$publicFun.copyFun(str);
    },
    // 个别复制
    myCopy(msg, type) {
      let str = "";
      if (type == 1) {
        msg = msg.map((item) => {
          return item ? item : "其它";
        });
        str = `媒体性质:${msg}`;
      }
      if (type == 2) {
        msg = msg.map((item) => {
          return item ? item : "无";
        });
        str = `来源/作者:${msg}`;
      }
      msg = msg ? msg : "无";
      if (type == 3) {
        str = `事件分类:${msg}`;
      } else if (type == 4) {
        str = `关键字:${msg}`;
      } else if (type == 7) {
        str = `标题:${this.textData.title}`;
      } else if (type == 8) {
        str = `链接:${this.textData.website}`;
      }else if (type == 9) {
        str = `作者ID:${this.textData.authorId}`;
      }
      this.$publicFun.copyFun(str);
    },
    lookOriginal(web) {
      window.open(web);
    },
    async getMsginfo() {
      const res = await getMsginfo({
        dataId: this.dataId,
        organId: this.organId,
        reportOrganId: this.$store.state.user.organizationId,
      });
      if (res.data.data) {
        this.textData = res.data.data;
        if (this.textData.eventClass) {
          this.textData.eventList = this.textData.eventClass.split(" ");
          let reg = new RegExp(" ", "g"); //g代表全部
          this.textData.eventClass = this.textData.eventClass.replace(
            reg,
            "<br/>"
          );
        } else {
          this.textData.eventList = [];
        }
        if (this.textData.keyword) {
          this.textData.keywordList = this.textData.keyword.split(" ");
          this.textData.keywordArry = this.textData.keyword.split(" ");
          if (this.textData.keywordList.length > 10) {
            this.textData.keywordList = this.textData.keywordList.slice(0, 10);
          }
          let reg = new RegExp(" ", "g"); //g代表全部
          this.textData.keyword = this.textData.keyword.replace(reg, "<br/>");
        }
        if (this.textData.content) {
          this.textData.contentList = this.textData.content.split("\n");
        }
      }
      // this.heightText();
      this.loading = false;
    },
    async monitorList() {
      let data = {
        dataId: this.dataIds,
        montype: this.montype,
        monitorId: this.cityId,
      };
      const res = await monitorIndex(data);
      if (res.data.data.map) {
        this.textData = res.data.data.map;
        if (this.textData.eventClass) {
          this.textData.eventList = this.textData.eventClass.split(" ");
          let reg = new RegExp(" ", "g"); //g代表全部
          this.textData.eventClass = this.textData.eventClass.replace(
            reg,
            "<br/>"
          );
        } else {
          this.textData.eventList = [];
        }
        if (this.textData.keyword) {
          this.textData.keywordList = this.textData.keyword.split(" ");
          this.textData.keywordArry = this.textData.keyword.split(" ");
          if (this.textData.keywordList.length > 10) {
            this.textData.keywordList = this.textData.keywordList.slice(0, 10);
          }
          let reg = new RegExp(" ", "g"); //g代表全部
          this.textData.keyword = this.textData.keyword.replace(reg, "<br/>");
        }
        if (this.textData.content) {
          this.textData.contentList = this.textData.content.split("\n");
        }
      }

      // this.heightText();
      this.loading = false;
    },
    heightText() {
      if (this.textData.keyword) {
        let word = this.textData.keyword.split("<br/>");
        if (word[word.length - 1] == "") {
          word.pop();
        }
        word.forEach((ite) => {
          let reg = new RegExp(ite, "g"); //g代表全部
          if (this.textData.title) {
            this.textData.title = this.textData.title.replace(
              reg,
              '<span style="color:red">' + ite + "</span>"
            );
          }
          if (this.textData.contentList) {
            for (let i = 0; i < this.textData.contentList.length; i++) {
              this.textData.contentList[i] = this.textData.contentList[
                i
              ].replace(reg, '<span style="color:red;">' + ite + "</span>");
              // font-weight:800;font-size:18px
            }
          }
        });
      }
    },
    //数据上报
    async dataReport(item) {
      let data = {
        infoType: 0,
        inforMsgId: item.dataId,
        organizationId: this.$store.state.user.organizationId,
        reportOrganId: item.organId,
      };
      const res = await dataReport(data);
      if (res != undefined) {
        if (res.data.data.code !== 200) {
          this.$message({
            message: res.data.data.msg,
            type: "warning",
          });
        } else {
          this.$message({
            message: res.data.data.msg,
            type: "success",
          });
        }
      }
      this.getMsginfo();
    },
  },
  created() {
    let params = JSON.parse(decodeURIComponent(this.$route.query.info));
    if (params) {
      this.dataId = params.id;
      this.organId = params.organId;
    }
  },
  mounted() {
    if (this.types == "首页监测") {
      this.monitorList();
    } else {
      this.getMsginfo();
    }
  },
};
</script>

<style scoped>
.information-haeder {
  justify-content: space-between;
  display: flex;
  padding: 10px 24px;
  width: 100%;
  height: 56px;
  background: #ffffff;
}

.breadcrumb {
  margin-top: 77px;
  margin-left: 24px;
}

.quan {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #cccccc;
  border-radius: 50%;
}

.gengduo-link {
  font-size: 14px;
  cursor: pointer;
  color: #2e59ec;
  margin-left: 5px;
}

.xiangq {
  margin-top: 4px;
  margin-left: 16px;
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}

.styleMargin {
  margin-right: 5px;
}

.information-box {
  padding: 0 24px 24px 24px;
}

.informaton-main {
  padding: 35px 32px 28px 35px;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
}

.main-top {
  position: relative;
  padding: 40px 210px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #e4e6ec;
}

.main-top-left {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 37px;
  height: 55px;
  background: url("../assets/img/views/beijing.png");
  background-size: 37px 55px;
}

.main-top-right {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 166px;
  height: 180px;
  background: url("../assets/img/views/beijing.png");
}

.center-title {
  font-size: 30px;
  font-weight: bold;
  color: #333333;
  max-width: 1060px;
}

.type {
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  padding: 0 8px;
  height: 24px;
}

.website {
  margin-left: 16px;
  background-color: #868bff;
}

.original {
  display: flex;
  margin-left: 16px;
  cursor: pointer;
  font-size: 14px;
  color: #2e59ec;
}

.original span:nth-child(1) {
  margin-top: 2px;
  margin-right: 5px;
}

.center-timer {
  display: flex;
  justify-content: space-between;
  margin-left: 24px;
  font-size: 14px;
  color: #999999;
}

.center-meiti,
.center-source,
.center-fenlei {
  position: relative;
  height: 100%;
  display: flex;
  font-size: 14px;
  color: #999999;
}

.center-source,
.center-fenlei {
  margin-left: 40px;
}

.center-meiti .img,
.center-source .img,
.center-fenlei .img {
  position: absolute;
  right: 0;
  top: 7px;
  margin: 0;
}

.center-bottom {
  display: flex;
  height: 35px;
  margin-top: 16px;
}

.center-bottom span {
  display: inline-block;
}

.gengduo {
  padding-left: 8px;
  width: 46px;
  height: 20px;
  cursor: pointer;
  color: #2e59ec;
  font-size: 14px;
}

.center-key-box {
  display: flex;
  align-items: center;
}

.center-key {
  max-width: 760px;
  display: flex;
  font-size: 14px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.center-key span,
.center-key div {
  width: 100%;
}

.gengduo-link-box {
  position: relative;
}

.gengduo-link-box img {
  position: absolute;
  top: 16%;
  right: -62%;
}

.main-text {
  line-height: 26px;
  text-indent: 2em;
  font-size: 14px;
  color: #333333;
}

.caozuo-center {
  line-height: 24px;
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.comment-box-yujing-box {
  display: flex;
  align-items: center;
}
.quick_copy {
  color: #2e59ec;
  cursor: pointer;
  margin-left: 10px;
  font-size: 14px;
}
.zb_sentiment_copy {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-left: 5px;
  cursor: pointer;
}
</style>
